module.exports = __webpack_public_path__ + "static/media/lumbering17.0925f889.jpg";